import * as React from "react";
import "./message.scss";
export interface Iprops {
    Message:String;
}
export default class CommonMessage extends React.Component<Iprops,{}> {
  public render() {
    return (
      <div className='mesagecontainer'>
        <div>
          {this.props.Message}
        </div>
        <p>Should you have any questions please feel free to <a href="mailto:sales@iglobe.dk" target="_blank" rel="noopener">contact us</a>. We can also offer you a demo or assist you in the implementation. As it is a simple product, we believe it will not take more than just 30 min. <a href="https://outlook.office365.com/owa/calendar/iGlobeOffice365@iglobe.dk/bookings/" target="_blank" rel="noopener">Book us now</a></p>
      </div>
    );
  }
 
}
